import * as React from "react";
import classnames from "classnames";
/* empty css                   */
const BrandListItem = ({ url, children, className }) => /* @__PURE__ */ React.createElement("a", { className: classnames("brand-list-item", className), href: url }, children);
const BrandListItem$1 = React.memo(BrandListItem);
export {
  BrandListItem$1 as default
};
//# sourceMappingURL=BrandListItem.js.map
